import { cn } from "@/lib/utils";

interface LogoProps {
  /** Mark size in pixels. */
  size?: number;
  /** Render the "Stayline" wordmark beside the mark. */
  withWordmark?: boolean;
  className?: string;
}

/**
 * Brand lockup: the generated bell-in-arch mark, optionally paired with the
 * bold sans wordmark. The mark is decorative; callers provide their own
 * surrounding label for screen readers where needed.
 */
export function Logo({ size = 36, withWordmark = false, className }: LogoProps) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img
        src="/brand/logo-mark.png"
        alt=""
        width={size}
        height={size}
        className="shrink-0 rounded-[28%] shadow-xs ring-1 ring-border/60"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <span className="font-display text-[1.05rem] font-bold tracking-tight text-foreground">
          Stayline
        </span>
      )}
    </span>
  );
}
